var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _symbol12, _symbol13, _symbol14, _symbol15, _symbol16, _symbol17, _symbol18, _symbol19, _symbol20, _symbol21, _symbol22, _symbol23;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWdaSprite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "angle-down",
    viewBox: "0 0 10 6"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    d: "M.004.878l4.69 4.432L9.342.878"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow-left",
    viewBox: "0 0 12 9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.082 4.5H1.58203",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 1L1 4.5L4.5 8",
    fill: "none"
  }))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    id: "arrow2",
    viewBox: "0 0 33 32"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5L16.5 31L29 18.5L26.5 16L14 28.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 18.5L16.5 31L19 28.5L6 16L3.5 18.5Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 21L14 18.5L16.5 16L19 18.5L16.5 21Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 16L14 13.5L16.5 11L19 13.5L16.5 16Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 11L14 8.5L16.5 6L19 8.5L16.5 11Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 6L14 3.5L16.5 1L19 3.5L16.5 6Z",
    stroke: "none"
  }))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    id: "back",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 9,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 15,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 6,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 3,
    height: 3,
    transform: "rotate(-90 8 21)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 24,
    width: 3,
    height: 3,
    transform: "rotate(-90 11 24)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 27,
    width: 3,
    height: 3,
    transform: "rotate(-90 14 27)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 18,
    width: 3,
    height: 3,
    transform: "rotate(-90 5 18)",
    stroke: "none"
  }))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    id: "btn-arrow",
    viewBox: "0 0 28 28"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 20,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 16,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 8,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 4,
    width: 4,
    height: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 4,
    height: 23,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    width: 4,
    height: 23,
    transform: "rotate(90 28 0)",
    stroke: "none"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    id: "close",
    viewBox: "0 0 32 32"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 18,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 21,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 24,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 9,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 15,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 12,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 6,
    width: 3,
    height: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 21,
    width: 3,
    height: 3,
    transform: "rotate(-90 17 21)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 24,
    width: 3,
    height: 3,
    transform: "rotate(-90 20 24)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 27,
    width: 3,
    height: 3,
    transform: "rotate(-90 23 27)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 12,
    width: 3,
    height: 3,
    transform: "rotate(-90 8 12)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 18,
    width: 3,
    height: 3,
    transform: "rotate(-90 14 18)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 15,
    width: 3,
    height: 3,
    transform: "rotate(-90 11 15)",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 9,
    width: 3,
    height: 3,
    transform: "rotate(-90 5 9)",
    stroke: "none"
  }))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    id: "facebook",
    viewBox: "0 0 11 23"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M7.06436 22.6042V12.2939H10.2754L10.7547 8.27511H7.06436V5.71303C7.06436 4.54563 7.3615 3.76047 8.91432 3.76047H10.8889V0.154965C10.5438 0.10331 9.37441 0 8.0133 0C5.16647 0 3.22066 1.86991 3.22066 5.31012V8.27511H0V12.2939H3.22066V22.6042H7.06436Z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    id: "google",
    viewBox: "0 0 29 30"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7064 7.82351C20.2732 7.49213 19.8699 7.15133 19.4359 6.85763C18.4434 6.18545 17.3435 5.79917 16.1602 5.63287C15.38 5.52237 14.5895 5.50628 13.8055 5.58494C12.6053 5.70581 11.4437 6.08138 10.3961 6.68723C8.49678 7.77436 7.13899 9.35672 6.30491 11.3909C5.73916 12.7725 5.54075 14.2251 5.64824 15.7148C5.81716 18.0546 6.72599 20.065 8.34362 21.7363C9.5321 22.9651 10.963 23.7844 12.6081 24.2095C13.6625 24.4819 14.7382 24.5262 15.8139 24.425C17.3123 24.2841 18.738 23.8634 19.9762 22.9729C21.4746 21.8936 22.5455 20.4742 23.0474 18.6526C23.1012 18.4581 23.1339 18.2578 23.1844 18.0226H14.8008C14.796 17.9247 14.7895 17.8588 14.7895 17.7924C14.7895 16.2236 14.7923 14.6547 14.7847 13.0859C14.7847 12.8917 14.8461 12.8467 15.0271 12.8467C19.5289 12.8508 24.0306 12.8508 28.5323 12.8467C28.7287 12.8467 28.7833 12.9286 28.8116 13.1023C29.0484 14.5605 29.052 16.0249 28.8782 17.4852C28.4956 20.7044 27.3313 23.5742 25.0744 25.9263C23.7918 27.2624 22.2752 28.2533 20.5682 28.9427C18.4782 29.7841 16.3037 30.0802 14.0686 29.9819C11.5894 29.8717 9.2961 29.1401 7.16404 27.8613C4.50705 26.2671 2.57704 24.0228 1.30734 21.18C0.792913 20.0344 0.425026 18.8269 0.212619 17.5868C-0.0253994 16.1941 -0.0548989 14.7961 0.0808806 13.3907C0.212345 12.0341 0.536415 10.7038 1.04305 9.4411C1.99351 7.06531 3.40626 5.02049 5.37951 3.39839C6.96417 2.09521 8.79351 1.13197 10.7565 0.567098C12.7181 -0.00637023 14.7131 -0.123112 16.7296 0.118974C19.7382 0.479849 22.3495 1.7296 24.5802 3.80228C24.6671 3.8842 24.7164 3.93622 24.6048 4.04395C23.3179 5.29165 22.0328 6.54154 20.7497 7.79361C20.7363 7.80501 20.7218 7.81503 20.7064 7.82351Z",
    stroke: "none"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    id: "play",
    viewBox: "0 0 20 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 24L20 12L0 0V24Z",
    fill: "white"
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    id: "plus",
    viewBox: "0 0 19 19"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 9.91309L19 9.91308",
    fill: "none",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.91406 19L9.91406 -4.76837e-07",
    fill: "none",
    strokeWidth: 2
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    id: "quest",
    viewBox: "0 0 25 25"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("text", {
    stroke: "none",
    fontFamily: "ProximaNova-Regular, Proxima Nova",
    fontSize: 16,
    fontWeight: 400
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 8,
    y: 17
  }, "?")), /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "none"
  })))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    id: "star-logo",
    viewBox: "0 0 63 62"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5067 23.6826H14.9922V31.1647H22.5067V23.6826Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.30218 23.6826H0V28.9619H5.30218V23.6826Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.9914 31.1631H9.07422V37.0547H14.9914V31.1631Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0342 62L30.193 47.4166H22.5059V39.4043H17.44L10.0342 62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.9997 23.6822H37.9924L30.2641 0L22.5359 23.6822H30.0242V31.1643H22.5059V39.4043H30.2604V47.3643H30.2641L50.4979 62L42.7697 38.3178L62.9997 23.6822Z"
  })))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    id: "star",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 1.14587L14.6942 9.43767H23.4128L16.3593 14.5623L19.0535 22.8541L12.0001 17.7295L4.94666 22.8541L7.64082 14.5623L0.587402 9.43767H9.30591L12.0001 1.14587Z",
    stroke: "none"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    id: "tg",
    viewBox: "0 0 20 17"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M18.6488 0.109066L0.933494 6.89754C-0.275527 7.37939 -0.268158 8.04959 0.713124 8.34841L5.13392 9.71875L6.82454 14.8687C7.03017 15.4324 6.92903 15.656 7.5245 15.656C7.98399 15.656 8.18829 15.4477 8.44416 15.1994C8.60692 15.041 9.57347 14.1073 10.6546 13.0644L15.2502 16.4387C16.0962 16.9046 16.7064 16.6623 16.9173 15.658L19.9315 1.53265C20.239 0.302736 19.458 -0.252986 18.6488 0.109066ZM5.8245 9.40462L15.7833 3.16188C16.2803 2.86239 16.7365 3.02345 16.3621 3.35356L7.83529 10.9979L7.50038 14.5166L5.8245 9.40462Z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-1",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 12,
    height: 12
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 6,
    height: 6
  })))), _symbol16 || (_symbol16 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-2",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 18,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    y: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 6,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 6,
    height: 6
  })))), _symbol17 || (_symbol17 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-3",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-90 12 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-90 24 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-90 18 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-90 18 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-90 24 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-90 24 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-90 24 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 12 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 12,
    height: 12,
    transform: "rotate(-90 18 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-90 18 18)",
    fill: "#1C1C20"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 12 12)",
    fill: "#1C1C20"
  })))), _symbol18 || (_symbol18 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-4",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 12 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-180 6 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 12 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 18 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 6 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 18 6)"
  })))), _symbol19 || (_symbol19 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-5",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 30,
    width: 6,
    height: 6,
    transform: "rotate(90 30 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(90 24 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(90 18 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(90 30 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 6,
    height: 6,
    transform: "rotate(90 6 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(90 12 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(90 12 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(90 18 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(90 24 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(90 6 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(90 18 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(90 6 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(90 12 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    width: 6,
    height: 6,
    transform: "rotate(90 18 0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(90 30 12)"
  })))), _symbol20 || (_symbol20 = /*#__PURE__*/React.createElement("symbol", {
    id: "title-pixel-6",
    viewBox: "0 0 30 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-180 18 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 12 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-180 12 30)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 12 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 18 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-180 18 6)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-180 6 12)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 24,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 24)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 18,
    width: 6,
    height: 6,
    transform: "rotate(-180 30 18)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 30,
    width: 6,
    height: 6,
    transform: "rotate(-180 24 30)"
  })))), _symbol21 || (_symbol21 = /*#__PURE__*/React.createElement("symbol", {
    id: "twitter",
    viewBox: "0 0 22 18"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 2.11696C21.1893 2.47471 20.3196 2.71759 19.4071 2.8259C20.3393 2.26794 21.0548 1.38177 21.3895 0.328211C20.5165 0.846785 19.5515 1.22095 18.5242 1.42444C17.7004 0.548113 16.5287 0 15.229 0C12.7379 0 10.7161 2.02178 10.7161 4.5129C10.7161 4.86737 10.7555 5.21199 10.8343 5.54021C7.0828 5.35313 3.75802 3.55453 1.53275 0.82381C1.14546 1.49008 0.922274 2.26466 0.922274 3.09175C0.922274 4.65732 1.71983 6.03909 2.93093 6.84649C2.19245 6.82351 1.49664 6.62002 0.88617 6.28196C0.88617 6.30166 0.88617 6.31807 0.88617 6.33776C0.88617 8.52365 2.44189 10.3485 4.50634 10.762C4.1289 10.8638 3.72848 10.9196 3.31822 10.9196C3.02611 10.9196 2.74385 10.89 2.46815 10.8375C3.04252 12.6296 4.70983 13.9358 6.68238 13.972C5.13651 15.1831 3.1935 15.9051 1.07653 15.9051C0.712218 15.9051 0.354468 15.8821 0 15.8428C1.99552 17.1228 4.36849 17.8711 6.91869 17.8711C15.2192 17.8711 19.7583 10.9951 19.7583 5.03148C19.7583 4.83455 19.755 4.64091 19.7452 4.44726C20.6281 3.81053 21.3928 3.01626 21.9967 2.1104L22 2.11696Z"
  }))), _symbol22 || (_symbol22 = /*#__PURE__*/React.createElement("symbol", {
    id: "vkontakte",
    viewBox: "0 0 25 15"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.9493 1.0157C24.1161 0.430217 23.9493 0 23.1553 0H20.5297C19.8621 0 19.5543 0.371644 19.3874 0.78146C19.3874 0.78146 18.0521 4.2065 16.1606 6.43129C15.5487 7.0753 15.2705 7.2802 14.9367 7.2802C14.7698 7.2802 14.5282 7.07529 14.5282 6.48986V1.0157C14.5282 0.313122 14.3345 0 13.7781 0H9.65213C9.23494 0 8.98403 0.326085 8.98403 0.635126C8.98403 1.30116 9.92974 1.45475 10.0272 3.3283V7.39735C10.0272 8.28947 9.87413 8.45122 9.54032 8.45122C8.65023 8.45122 6.48507 5.01088 5.20093 1.07423C4.94927 0.309079 4.69686 0 4.02583 0H1.40022C0.650043 0 0.5 0.371644 0.5 0.78146C0.5 1.51333 1.39014 5.14328 4.64464 9.94414C6.81429 13.2228 9.87118 15 12.6528 15C14.3218 15 14.5283 14.6053 14.5283 13.9253V11.4474C14.5283 10.6579 14.6864 10.5003 15.2149 10.5003C15.6043 10.5003 16.2719 10.7052 17.8296 12.286C19.6099 14.1595 19.9034 15 20.9047 15H23.5304C24.2805 15 24.6556 14.6053 24.4392 13.8263C24.2024 13.0499 23.3525 11.9234 22.2247 10.5881C21.6127 9.82704 20.6947 9.00742 20.4165 8.59751C20.0271 8.07064 20.1384 7.8364 20.4165 7.36806C20.4165 7.36806 23.6155 2.62572 23.9493 1.0157Z"
  }))), _symbol23 || (_symbol23 = /*#__PURE__*/React.createElement("symbol", {
    id: "zen",
    viewBox: "0 0 31 30"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.74 12.76c2.57 2.202 8.24 2.362 11.354 2.266.002-1.225-.048-4.146-.488-7.91-.587-5.015-3.468-5.549-5.603-5.975-1.692-.339-6.267-.409-8.09-.423-.11 1.743-.384 9.288 2.828 12.041M12.318 12.76c3.212-2.754 2.937-10.3 2.828-12.043-1.773.013-6.45.08-8.164.424-2.135.426-5.016.96-5.603 5.976-.44 3.76-.49 6.68-.488 7.906 3.098.102 8.836-.043 11.427-2.264M15.146 29.877h.005c.112-1.893.328-9.245-2.833-11.955-2.59-2.22-8.329-2.365-11.427-2.264 0 1.276.059 4.145.488 7.816.587 5.016 3.469 5.55 5.603 5.976 1.715.343 6.392.41 8.164.424v.003zM18.74 17.922c-3.158 2.708-2.945 10.052-2.832 11.951 1.82-.014 6.401-.084 8.095-.423 2.135-.427 5.016-.96 5.603-5.976.43-3.673.488-6.544.488-7.818-3.114-.097-8.783.063-11.353 2.266"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWdaSprite);
export default __webpack_public_path__ + "static/media/wda-sprite.2c6fcc98e6e4d7dde2e7c42898df6698.svg";
export { ForwardRef as ReactComponent };